var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.conferenceIsOver)?_c('div',{staticClass:"notification is-success has-text-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('atrium.conferenceOver'))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }